import { render, staticRenderFns } from "./SubPropertyDataTablePanel.vue?vue&type=template&id=466151cb&scoped=true"
import script from "./SubPropertyDataTablePanel.vue?vue&type=script&lang=js"
export * from "./SubPropertyDataTablePanel.vue?vue&type=script&lang=js"
import style0 from "./SubPropertyDataTablePanel.vue?vue&type=style&index=0&id=466151cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466151cb",
  null
  
)

export default component.exports